import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import Layout from '../../parts/Layout';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';
 
export default function GenerateQR (){
    let default_data = {
        "prefix": `${window.location.origin}/product-units/qr/`,
        "caption": "",
        "start": "",
        "end": "",
    }

    const toast = useRef(null);
    const [loading, setLoading] = useState(0);
    const navigate = useNavigate();
    const [errors, setErrors] = useState([]);
    const [form_data, setFormData] = useState(default_data);
   
    // useEffect(() => {

    // }, []);

    function inputChange(e) {
        let { value, name } = e.target;
        setFormData(prev => ({
                        ...prev,
                        [name]: value
                    }))
    }

    function generate(){
        if(!form_data.start && !form_data.end){
            toast.current.show({severity:'error', detail:'Please complete the form.', life: 10000});
        }
        else{
            const url = `/tools/qr-range-generator-print?caption=${form_data.caption}&start=${form_data.start}&end=${form_data.end}&prefix=${form_data.prefix}`
            window.open(url, '_blank');
        }
    }

    function clear(){
        setFormData(default_data)
    }

    return (
        <>
        <Toast ref={toast} position="top-right" />
        <Layout page_title="QR Code Range Generator" menu="qr-range-generator" parent_text='Tools' breadcrumbs={true}>
            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <form>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                    <label>Prefix<span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-5 col-lg-4 form-group">
                                    <InputText 
                                        placeholder="Enter Prefix"
                                        name='prefix'
                                        className='w-100'
                                        value={form_data.prefix}
                                        onChange={inputChange} 
                                    />
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                    <label>Caption<span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-5 col-lg-4 form-group">
                                    <InputText 
                                        placeholder="Enter Caption"
                                        name='caption'
                                        className='w-100'
                                        value={form_data.caption}
                                        onChange={inputChange} 
                                    />
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                    <label>Value Range<span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-5 col-lg-4 form-group">
                                    <div className="p-inputgroup flex-1">
                                        <InputNumber 
                                            name="start"
                                            placeholder="Start"
                                            value={form_data.start}
                                            onValueChange={inputChange} 
                                            inputClassName="w-100"
                                            min={1}
                                        />
                                        <InputNumber 
                                            name="end"
                                            placeholder="End"
                                            value={form_data.end} 
                                            onValueChange={inputChange} 
                                            min={form_data.start}
                                            inputClassName="w-100" 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className='text-right mt-4'>
                        <button type='button' className='btn btn-success ml-3' onClick={(e) => generate()}>Generate</button>
                        <button type='button' className='btn btn-outline-dark ml-3' onClick={(e) => clear()}>Clear</button>
                    </div>
                </form>
            </div>
        </Layout>
        </>
    )
}